import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { InformationCircleIcon } from '@heroicons/react/24/outline'
import { Button } from 'src/components/button'
import type { Property } from 'src/services/properties/models'
import { InfoHint } from 'src/components/info-hint'

type CoOnboardingBannerProps = {
  property: Property
  onSetupClick: () => void
}

export function CoOnboardingBanner({ property, onSetupClick }: CoOnboardingBannerProps) {
  const { t } = useTranslation()
  const [dismissed, setDismissed] = useState(false)

  const shouldShow =
    property.country === 'CO' && property.reportsTra === false && property.reportsSire === false

  if (!shouldShow || dismissed) return null

  return (
    <div
      data-testid="co-onboarding-banner"
      className="rounded-lg border border-accent bg-accent-50 p-5"
    >
      <div className="flex items-start gap-3">
        <InformationCircleIcon className="mt-0.5 h-6 w-6 shrink-0 text-accent" aria-hidden="true" />
        <div className="flex-1">
          <h3 className="text-base font-semibold text-accent-800">
            {t('reporting.onboarding.bannerHeading')}
            <InfoHint text={t('reporting.onboarding.bannerDescription')} className="ml-1.5" />
          </h3>
          <div className="mt-4 flex items-center gap-3">
            <Button variant="primary" onClick={onSetupClick} data-testid="co-onboarding-setup-btn">
              {t('reporting.onboarding.setupReporting')}
            </Button>
            <Button
              variant="text"
              tone="accent"
              type="button"
              onClick={() => setDismissed(true)}
              className="text-sm"
              data-testid="co-onboarding-skip-btn"
            >
              {t('reporting.onboarding.skipForNow')}
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}
